import React, { FC } from 'react';
import { vars } from '../../../reactive';
import { clearLocalStorage } from '../../../utils';
import { FORM_PAGES } from '../../Form/types';
import FormContainer from '../../Shared/FormContainer/FormContainer';
import { Button } from '../../Shared/FormContainer/styled';
import LoadingSpinner from '../../Shared/LoadingSpinner/LoadingSpinner';
import { CenteredInfoContainer } from '../styled';
import { FORM_INFO_COMPONENT_TYPES } from '../types';
import { FormBody, FormInfoWrapper, ProssecingPayment } from './styled';

interface FormInfoBookingOrderProps {
  type: keyof typeof FORM_INFO_COMPONENT_TYPES;
  title: string;
  body: string;
  loading?: boolean;
  children?: React.ReactNode;
  aboveTitleElement?: React.ReactNode;
  error?: boolean;
  errorMessage?: string;
}
const FormInfoBookingOrder: FC<FormInfoBookingOrderProps> = ({ type, title, body, loading, children, aboveTitleElement, error, errorMessage }) => {
  const { title: defaultTitle, body: defaultBody } = FORM_INFO_COMPONENT_TYPES[type];
  const isNoSlotError = errorMessage && errorMessage?.includes('The selected slot is no longer available. Please select a different date.');
  return (
    <FormInfoWrapper>
      <div>
        {loading && (
          <ProssecingPayment>
            <LoadingSpinner />
            <span>Booking is being processed</span>
          </ProssecingPayment>
        )}
        {!loading && !error && (
          <FormContainer title={title || defaultTitle} noNextButton noPreviousButton aboveTitleElement={aboveTitleElement} centerTitle>
            <CenteredInfoContainer>
              <FormBody>{body || defaultBody}</FormBody>
              {children}
            </CenteredInfoContainer>
          </FormContainer>
        )}

        {error && (
          <ProssecingPayment>
            <span>
              {isNoSlotError
                ? 'The selected slot is no longer available. Please select a different date or time for your bookings.'
                : errorMessage
                ? `${errorMessage} please try again.`
                : 'Something went wrong. Please contact support at support@collar.pet'}
            </span>
            {isNoSlotError && (
              <Button
                wide
                type="button"
                onClick={() => {
                  clearLocalStorage();
                  vars.formPage(FORM_PAGES.PRODUCTS);
                }}
              >
                Go to services
              </Button>
            )}
          </ProssecingPayment>
        )}
      </div>
    </FormInfoWrapper>
  );
};

export default FormInfoBookingOrder;
